export default {
  methods: {
    copyText: function (txt) {
      navigator.clipboard.writeText(txt).then(
        () => {
          this.snackText = 'متن با موفقیت کپی شد';
          this.$refs.snackRef.snackModel = true;
          this.snackColor = '#4CAF50';
          this.snakIcon = 'mdi-check-circle';
        },
        () => {
          console.error('Failed to copy');
        },
      );
    },
    triggerOnEachItem: function (data, wholeData, evt) {
      const cellText = evt?.target?.textContent;
      if (['-', ''].every((item) => item !== cellText) && typeof cellText === 'string') {
        this.copyText(cellText);
      }
    },
  },
};
